export default __webpack_public_path__ + "static/media/group5.e1e7037c.png";